import { render } from "./PdpLrpSettings.vue?vue&type=template&id=318d29eb"
import script from "./PdpLrpSettings.vue?vue&type=script&lang=js"
export * from "./PdpLrpSettings.vue?vue&type=script&lang=js"

import "./PdpLrpSettings.vue?vue&type=style&index=0&id=318d29eb&lang=css"

import exportComponent from "C:\\Users\\jenkinsuser\\AppData\\Local\\Jenkins\\.jenkins\\workspace\\UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__